export const Footer = () => {
  return (
    <p className="mt-4 text-center text-muted-foreground text-body-sm">
      One moment please
    </p>
  );
};
